<template>
  <div class="xinxi">
    <el-table v-loading="loading" :data="dataList.list" :show-header="false" :row-style="{height: '0'}"
              :cell-style="{padding: '0'}">
      <el-table-column width="40px" type="index" :index="showIndex" align="right"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="left" min-width="500px">
        <template slot-scope="scope">
          <el-button type="text" @click="onClick(scope.row)">
            <span style="
          display:inline-block;
          width:200px;text-align: left;white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;">
            {{scope.row.a100}}
            </span>
            <span>
            {{scope.row.a298}}
            </span>
          </el-button>

        </template>
      </el-table-column>
      <!--      <el-table-column :show-overflow-tooltip="true" align="left" min-width="100%">-->
      <!--        <template slot-scope="scope">-->
      <!--          -->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column :show-overflow-tooltip="true" align="right" min-width="252px">
        <template slot-scope="scope">
          <span style="font-size: 16px"v-if="scope.row.a206">[{{scope.row.a206.substring(0,10)}}]</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 5px;margin-left: 20px" v-if="name==='detail'" :total="dataList.totalRow" :current-page.sync="dataList.pageNumber" :page-size.sync="dataList.pageSize"
                   layout="total, prev, pager, next, jumper"
                   @current-change="getNews"/>
  </div>
</template>
<script>
import {getSystemId} from "../../../utils/systemInfo";
import request from "../../../utils/request";
import getSystem from "../../../utils/getSystem";

export default {
  name:'standardNullify',
  props:{
    name:{
      type:String,
      required:true
    },
  num:{
    type:Number,
    default: 10
  },
    a100:{
      type: String,
      default: ''
    },
    a298:{
      type: String,
      default: ''
    },
    countTime:{
      type: String,
      default: ''
    },
    showActiveName:{
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      page:{
        pageNumber: 1,
        pageSize: 10,
        keyword:'',
        systemId: getSystemId(),
        a100: '',
        a298: '',
        countTime: ''
      },
      dataList:{
        pageNumber: 1,
        pageSize: 10,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      loading: false
    }
  },
  watch: {
    showActiveName: {
      handler(val) {
        this.getNews()
      }
    }
  },
  methods:{
    /**
     * 标准即将作废列表分页
     */
    async getNews(){
      this.loading = true
      if(this.page.systemId===''||this.page.systemId===null||this.page.systemId===undefined){
        await getSystem.getSystemInfo()
        this.page.systemId=getSystemId()
      }
      if(this.num !=''){
        this.page.pageSize=this.num
      }
      this.page.pageNumber=this.dataList.pageNumber
      this.page.a100 = this.a100
      this.page.a298 = this.a298
      this.page.countTime = this.countTime
      request.post('/portalController/querySoonVoidPage', this.page).then(rsp => {
        if (rsp.resultCode === '0') {
          this.dataList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '即将作废标准数据加载失败'
          })
        }
        this.loading = false
      })
    },
    /**
     * 自定义索引
     */
    showIndex(index){
      return index+1+'.'
    },
    onClick(row){
      if(this.name==='page'){
        this.$router.push({path:'/detail',query:{index:'23',id:row.id}})
      }else {
        let param={index:'23',id:row.id}
        this.$emit('listenNews',param)
      }
    }
  },
  mounted(){
    this.getNews()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/home/compoment/standardNullify.vue